import React from 'react';
import { PositionOverlay } from '@src/features/drone/pages/drones-page/components/position-overlay';
import { useFlightDroneProvider } from '@src/features/drone/provider/flight-drone-provider/hook';
import { DronesMapProps } from './types';
import EnRouteMap from './en-route';
import { DronesMainMap } from './main';
import { useDronesPage } from '@src/features/drone/context/drones-page-view-model';

const Map: React.FC<DronesMapProps> = (props) => {
  const { goTo, position, removePosition, resetGoHere, points } = props;
  const vm = useDronesPage();

  useFlightDroneProvider();

  React.useEffect(() => {
    if (vm.prevIsFlying && !vm.isFlying && vm.selectedDrone) {
      resetGoHere?.();
    }
  }, [vm.prevIsFlying, vm.isFlying, vm.selectedDrone, resetGoHere]);

  return (
    <React.Fragment>
      {vm.mapMode === 'enroute' ? (
        <EnRouteMap
          key={`${vm.effectiveMissionId}-${vm.selectedSerial ?? ''}`}
          goTo={goTo}
          position={position}
          removePosition={removePosition}
          points={points}
          resetGoHere={resetGoHere}
          missionId={vm.effectiveMissionId}
          rotation={
            vm.selectedDrone ? vm.rotations[vm.selectedDrone.serialNumber] : undefined
          }
          fallbackDroneSerial={vm.selectedFromRedux?.serialNumber}
          fallbackPosition={vm.enRouteFallbackPosition}
        />
      ) : (
        <DronesMainMap
          resetGoHere={resetGoHere}
          position={position}
          removePosition={removePosition}
          points={points}
          goTo={goTo}
        />
      )}

      {position && vm.selectedDrone && (
        <PositionOverlay
          position={position}
          location={vm.location}
          selectedDrone={vm.selectedDrone}
          isOnMission={vm.isFlying}
          displayCreateMission={vm.displayCreateMission}
          onClose={removePosition}
          goTo={goTo}
          removePosition={removePosition}
        />
      )}
    </React.Fragment>
  );
};

export default Map;
